import { useState, useCallback } from 'react'
import { teacherApi, TeacherBooking } from '@/services/api/teacher'

export function useTeacherBookings(limit?: number) {
  const [bookings, setBookings] = useState<TeacherBooking[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchBookings = useCallback(async () => {
    setIsLoading(true)
    setError(null)
    try {
      const data = await teacherApi.getUpcomingBookings(limit)
      setBookings(data.bookings || [])
    } catch (e: any) {
      console.error('[TeacherBookings] Fetch error:', e)
      setError(e?.detail || 'Vertretungen konnten nicht geladen werden')
    } finally {
      setIsLoading(false)
    }
  }, [limit])

  return {
    bookings,
    isLoading,
    error,
    fetchBookings,
  }
}